export default __webpack_public_path__ + "locales/fr/FormGallery.json?hash=3eb08daa878e3ae413664079623d3f8a";